var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMicrosoftTeams(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 9.81584V12.5527C18 13.6865 17.0599 14.6054 15.9 14.6054C14.7401 14.6054 13.8 13.6865 13.8 12.5527V9.13163H17.3C17.6868 9.13163 18 9.43781 18 9.81584ZM15.9 7.76319C16.6732 7.76319 17.3 7.15048 17.3 6.39476C17.3 5.63904 16.6732 5.02633 15.9 5.02633C15.1269 5.02633 14.5 5.63904 14.5 6.39476C14.5 7.15048 15.1269 7.76319 15.9 7.76319Z",
    fill: "#5059C9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.85 9.81584V13.579C14.85 15.5438 13.1557 17.1219 11.1169 16.9926C9.25665 16.8749 7.85 15.2838 7.85 13.4617V9.13162H14.15C14.5368 9.13162 14.85 9.43781 14.85 9.81584ZM11.35 8.1053C12.5099 8.1053 13.45 7.18639 13.45 6.05265C13.45 4.9189 12.5099 4 11.35 4C10.1901 4 9.25 4.9189 9.25 6.05265C9.25 7.18639 10.1901 8.1053 11.35 8.1053Z",
    fill: "#7B83EB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.35 8.1053C12.5098 8.1053 13.45 7.1863 13.45 6.05265C13.45 4.919 12.5098 4 11.35 4C10.1902 4 9.25 4.919 9.25 6.05265C9.25 7.1863 10.1902 8.1053 11.35 8.1053Z",
    fill: "#7B83EB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M11.7 13.6882V9.13162H7.85V13.4617C7.85 13.9865 7.97005 14.4907 8.1804 14.9475H10.4113C11.1232 14.9475 11.7 14.3837 11.7 13.6882Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M7.85 9.13162V13.4617C7.85 13.8585 7.92035 14.2431 8.0439 14.6054H10.3742C10.9776 14.6054 11.4665 14.1274 11.4665 13.5376V9.13162H7.85Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M11.2334 9.13162H7.85V13.4617C7.85 13.7361 7.88535 14.0036 7.9459 14.2632H10.3371C10.832 14.2632 11.2331 13.8712 11.2331 13.3874V9.13162H11.2334Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3 13.9211H4.7C4.31325 13.9211 4 13.6149 4 13.2369V7.76318C4 7.38515 4.31325 7.07896 4.7 7.07896H10.3C10.6867 7.07896 11 7.38515 11 7.76318V13.2369C11 13.6149 10.6867 13.9211 10.3 13.9211Z",
    fill: "url(#paint0_linear_1310_6467)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9238 8.78916H6.0762V9.37759H7.14265V12.2102H7.85735V9.37759H8.9238V8.78916Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1310_6467",
    x1: 4.2268,
    y1: 7.30065,
    x2: 10.6414,
    y2: 13.8632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5961C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A41AC"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftTeams);
export default __webpack_public_path__ + "static/media/MicrosoftTeams.c3833e724713f7f5da2c378c3527d8c1.svg";
export { ForwardRef as ReactComponent };